import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import PageBanner from '../../components/PageBanner/PageBanner';
import ScrollStackSection from '../../components/ScrollStackSection/ScrollStackSection';
import Footer from '../../components/Footer/Footer';
import './AboutUs.css';
import { AboutService } from '../../services/api';

const AboutUs: React.FC = () => {
    const [pageData, setPageData] = useState<any>(null);
    const [attorneys, setAttorneys] = useState<any[]>([]);
    // const [testimonials, setTestimonials] = useState<any[]>([]);
    // const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch all data in parallel
                const [pageRes, teamRes] = await Promise.allSettled([
                    AboutService.getPageData(),
                    AboutService.getTeamMembers(),
                    // AboutService.getTestimonials()
                ]);

                if (pageRes.status === 'fulfilled') setPageData(pageRes.value);
                if (teamRes.status === 'fulfilled') setAttorneys(teamRes.value || []);
                // if (testimonialsRes.status === 'fulfilled') setTestimonials(testimonialsRes.value || []);
            } catch (error) {
                console.error("Failed to fetch About Us data:", error);
            } finally {
                // setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // Helper to strip HTML tags if needed, or use dangerouslySetInnerHTML
    const createMarkup = (html: string) => ({ __html: html });

    return (
        <div className="about-us-page">
            <Header />
            <PageBanner
                title="About Us"
                subtitle="Leading the way in legal excellence and dedicated client service."
                backgroundImage={require('../../assets/images/hero_bg_new2.jpg')}
            />
            <main className="about-hero">
                <div className="about-kicker">
                    About Lawfirm
                </div>
                <h1 className="about-headline">
                    {pageData?.title?.rendered ? (
                        <span dangerouslySetInnerHTML={createMarkup(pageData.title.rendered)} />
                    ) : (
                        <>
                            <span className="serif-part">Offering strategic legal advice, </span>
                            <span className="sans-part">ethical legal representation, and result-oriented advocacy to secure justice with confidence</span>
                        </>
                    )}
                </h1>
            </main>

            <section className="founder-section">
                <div className="container">
                    <div className="founder-grid">
                        <div className="founder-image-wrapper">
                            <img src={require('../../assets/images/founder.png')} alt="S. R. S. Kannan" />
                            <div className="founder-role">ABOUT THE FOUNDER</div>
                            <h2 className="founder-name">S.R.S.Kannan, <span className="founder-creds">BBA.L.L.B</span></h2>
                        </div>
                        <div className="founder-text">
                            <p>
                                Advocate Kannan is the brain behind the entire operation and is known for his academic excellence, legal expertise, and unrelenting passion for justice. With a solid background in law and a doctorate that showcases his level of research and understanding, he has established the law firm on the foundations of honesty, hard work, and a commitment to his clients.
                            </p>
                            <p>
                                With extensive experience in his hands, Advocate Kannan is recognized for his pragmatic approach to both simple and complex cases. His unique ability to blend legal acumen with effective solutions has won him the confidence of clients from all walks of life.
                            </p>
                            <p>
                                During his tenure, the company has developed into a reputable law firm in Coimbatore, and this is based on professionalism, ethics, and the unwavering quest for the best possible results for clients. Advocate Kannan vision is that the legal profession is not only about representation but also about responsibility, and this involves guiding clients with clarity, confidence, and compassion at all times.
                            </p>
                            <p>
                                His vision has continued to motivate a team of committed lawyers who are dedicated to the same ideals of excellence, and this ensures that every client gets dependable and result-oriented legal assistance.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="experience-section">
                <div className="container">
                    <div className="experience-grid">
                        <div className="experience-image-left">
                            <img src={require('../../assets/images/ABOUT THE FOUNDER (1).jpg')} alt="Lawyer at desk" />
                        </div>
                        <div className="experience-content">
                            <div className="experience-number">
                                <span className="number">8</span>
                                <span className="plus">+</span>
                            </div>
                            <p className="experience-label">Years of Experience in<br />Legal Practice</p>
                            <div className="divider-line"></div>
                            <div className="experience-text">
                                {pageData?.content?.rendered ? (
                                    <div dangerouslySetInnerHTML={createMarkup(pageData.content.rendered)} />
                                ) : (
                                    <p>
                                        With more than 8 years of experience in the legal industry, our law firm has established a reputable name for providing reliable and goal-oriented legal assistance.
                                        Our experienced lawyers possess extensive knowledge of the law and a professional approach to deal with legal matters effectively. We understand the distinct circumstances of each client and provide them with straightforward advice at every step. Whether it is simple
                                        legal help or complicated legal proceedings, we are dedicated to defending your rights and securing the best possible results.
                                    </p>
                                )}
                            </div>
                            <Link className="consultation-btn-dark" to="/contact" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                                <b>Free Consultation</b>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="btn-icon">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polygon points="10 8 16 12 10 16 10 8" fill="currentColor"></polygon>
                                </svg>
                            </Link>
                        </div>
                        <div className="experience-image-right">
                            <img src={require('../../assets/images/ABOUT THE FOUNDER2.jpg')} alt="Statue of Justice" className="statue-img" />
                            <div className="scales-decoration">
                                <img src={require('../../assets/images/scales_illustration.png')} alt="Scales of Justice" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="banner-section" style={{ backgroundImage: `url(${require('../../assets/images/gavel_banner.png')})` }}>
                <div className="banner-overlay">
                    <div className="container">
                        <div className="banner-content">
                            <span className="diamond-icon">♦</span>
                            <h2>We offer expert legal solutions in <span className="serif-italic">corporate</span> matters nationwide</h2>
                            <span className="diamond-icon">♦</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="attorneys-section">
                <div className="container">
                    <div className="attorneys-grid">
                        <div className="attorneys-content">
                            <div className="section-kicker">
                                Meet Our Attorneys <span className="square-dot"></span>
                            </div>
                            <h2 className="attorneys-headline">
                                Strong represent and trusted counsel for complex <span className="serif-italic">legal Challenges.</span>
                            </h2>

                            <div className="attorneys-stats">
                                <div className="quill-bg">
                                    <img src={require('../../assets/images/Strong represent and trusted counsel for complex legal Challenges..jpg')} alt="" aria-hidden="true" />
                                </div>
                                <div className="stat-number">
                                    8<span className="plus">+</span>
                                </div>
                                <p className="stat-label">
                                    Experience Lawyers <span className="serif-italic">in<br /> Legal Service</span>
                                </p>
                            </div>

                            {/* Dynamic list of attorneys could go here if design permits, currently design favors 1 large image on right */}
                            {attorneys.length > 0 && (
                                <div className="attorneys-list-preview" style={{ marginTop: '20px' }}>
                                    {attorneys.map((attorney: any) => (
                                        <div key={attorney.id}>{attorney.title?.rendered}</div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="attorneys-image">
                            {/* Ideally fetch this image from API if available */}
                            <img src={require('../../assets/images/Strong represent and trusted counsel for complex legal Challenges..jpg')} alt="Senior Attorney" />
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <ScrollStackSection />
            </section>
            <Footer />
        </div>

    );
};

export default AboutUs;
